import React, { Component } from "react";
import arcaneIcon from "./ArcaneIcon2.png";
import chaosIcon from "./ChaosIcon2.png";
import divineIcon from "./DivineIcon2.png";
import natureIcon from "./NatureIcon2.png";
import technologyIcon from "./TechnologyIcon2.png";




    function aspectimageF(aspectImage){
        switch (aspectImage) {
            case "Chaos":
              return  chaosIcon
            case "Technology":
              return  technologyIcon
            case "Arcane":
              return  arcaneIcon
            case "Divine":
              return divineIcon
            case "Nature":
              return  natureIcon
            default:
              return null;
        }}



class AspectButton extends Component {
  render() {

    var backgroundImage = aspectimageF(this.props.aspectImage);

    var aspectfilterStyle = {
         backgroundRepeat: "no-repeat",
         display: "inline-block",
         backgroundSize:"35px",
         backgroundPosition: "center",
         backgroundColor:this.props.active === true ? "white" : "black",
         backgroundImage: `url(${backgroundImage})`,
         width: "38px"
       }

    return (
              <button type="button" style={aspectfilterStyle} className={this.props.active === true ? 'btn btn-secondary active' : 'btn btn-secondary'} id={"b"+ this.props.aspectImage}
              value={this.props.value} onClick={this.props.clickHandler} >&nbsp;</button>
    );
  }
}

export default AspectButton;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/FilterComponents/AspectButton.js